import { render, staticRenderFns } from "./buttonPermissions.vue?vue&type=template&id=662b41a2"
import script from "./buttonPermissions.vue?vue&type=script&lang=js"
export * from "./buttonPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports